export default __webpack_public_path__ + "locales/bg/DownloadDialog.json?hash=7935c19ff884db6723e63317bf7eec5d";